import { palette, TPalette } from '@shared/tokens/palette.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-12'],
  },
  label: {
    display: 'block',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: '12px',
    color: palette['grey-700'],
  },
  colorPicker: {
    display: 'flex',
    gap: anatomy['space-12'],
  },
  colorButton: (color: keyof TPalette) => ({
    width: anatomy['space-28'],
    height: anatomy['space-28'],
    borderRadius: anatomy.borderRadiusRound,
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    background: palette[color],
    ':hover': {
      background: `linear-gradient(0deg, ${colors.hoverBackground}, ${colors.hoverBackground}), ${String(palette[color])}`,
      outline: `1px solid ${colors.primaryBorder}`,
      outlineOffset: '-1px',
    },
  }),
});
